export default __webpack_public_path__ + "static/media/question-icon.be042afa.png";